<div class="container-fluid text-black-50">
    <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
        <ol class="breadcrumb  shadow-lg">
            <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/dashboard">Dashboard administration</a></li>
            <li class="breadcrumb-item active" aria-current="page">Gestion des comptes SoftPay</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-sm-6">
            <div class="card border-0">
                <div class="card-header border-0 generalbgColorV2">
                    <h5 class="card-title text-center text-white font-weight-bolder">Ajouter un utilisateur SoftPay</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="partenaireForm" #f="ngForm" (ngSubmit)="addpartenaire(f.value)">
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="font-weight-bolder">Etablissement Bancaire</label>
                                <input formControlName="etsbancaire" type="text" class="form-control" id="etsbancaire"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">Numero identification</label>
                                <input formControlName="nidentification" type="text" class="form-control"
                                    id="nidentification" placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="font-weight-bolder">nom responsable</label>
                                <input formControlName="lastName" type="text" class="form-control" id="lastName"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">prenom responsable</label>
                                <input formControlName="firstName" type="text" class="form-control" id="firstName"
                                    placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">email de connection</label>
                                <input formControlName="email" type="text" class="form-control" id="email"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">contact</label>
                                <input formControlName="phone" type="text" class="form-control" id="phone"
                                    placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputCity" class="font-weight-bolder">Ville de l'Etablissement</label>
                                <input formControlName="ville" type="text" class="form-control" id="ville">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="inputZip" class="font-weight-bolder">Quartier</label>
                                <input formControlName="quartier" type="text" class="form-control" id="quartier">
                            </div>
                        </div>


                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="font-weight-bolder">mot de passe</label>
                                <input formControlName="password" type="password" class="form-control" id="password">

                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="font-weight-bolder">confirmation mot de passe</label>
                                <input formControlName="confirmPassword" type="password" class="form-control"
                                    id="confirmPassword">
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary"
                            [disabled]="!partenaireForm.valid">Ajouter</button>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card   border-0">
                <div class="card-header generalbgColorV2">
                    <h5 class="card-title text-white text-center font-weight-bolder">Utilisateurs du compte type 12</h5>
                </div>
                <div class="card-body">
                    <div class="row" *ngFor="let p of softPayOperatorList;">
                        <div class="col-sm-6">
                            <div class="card border-0">
                                <div class="card-header generalbgColorV2">
                                    <h5 class="card-title text-white text-center font-weight-bolder">{{p.firstName}} {{p.lastName}}</h5>
                                  </div>
                                <div class="card-body ">
                                    <h6 class="card-title ">Email<strong
                                        class="ml-3">{{p.email}}</strong>
                                    </h6>
                                    <h6 class="card-title ">Contact<strong
                                        class="ml-3">{{p.phone}}</strong>
                                    </h6>
                                    <h6 class="card-title">Type utilisateur<strong
                                        class="ml-3">{{p.typ}}</strong>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p *ngIf="softPayOperatorList.length===0" class="mb-0">
                        Aucun utilisateur type 12 trouvé.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
